import React from "react";
// import type { Folder } from '../../../interfaces/IFolder';

// const PhotoCard = React.memo(({ src, onDelete }: { src: string; onDelete: () => void }) => {
//   return (
//     <div className="photo-card">
//       <img src={src} alt={file} loading="lazy" />
//       <button className="delete-btn" onClick={onDelete}>✖</button>
//     </div>
//   );
// });

type PhotoCardProps = {
  src: string;
  alt: string;
  onDelete: () => void;
};

const PhotoCard = React.memo(({ src, alt, onDelete }: PhotoCardProps) => {
  return (
    <div className="photo-card">
      <img src={src} alt={alt} loading="lazy" />
      <button className="delete-btn" onClick={onDelete}>✖</button>
    </div>
  );
});

            //       <div key={file} className="photo-card">
            //         <img
            //           src={`${import.meta.env.VITE_BACKEND_URL}/images/${folder.name}/${file}`}
            //           alt={file}
            //           loading="lazy"
            //         />
            //         <button
            //           className="delete-btn"
            //           onClick={() => remove(folder.name, file)}
            //         >
            //           ✖
            //         </button>
            //       </div>

export default PhotoCard;
